
import { configureStore } from '@reduxjs/toolkit';
import shoppingReducer from './slices/shoppingSlice';
import { loggerMiddleware } from "./loggerMiddleware"
import venueReducer from './slices/venuSlice';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import paymentReducer from './slices/paymentSlice';
import globalReducer from './slices/global.Slice';

export const store = configureStore({
  reducer: {
    shopping: shoppingReducer,
    venues: venueReducer,
    auth: authReducer,
    user: userReducer,
    payment: paymentReducer,
    global: globalReducer
  },
  devTools: import.meta.env.VITE_API_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
      .concat(loggerMiddleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
